export default "__VITE_ASSET__BHtUltU3__"